import { Alert, Autocomplete, Badge, Box, Button, Chip, Fade, FormControl, IconButton, InputLabel, List, ListItem, ListItemSecondaryAction, Menu, MenuItem, Select, Stack, TextField, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDispatch, useSelector } from 'react-redux';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { v4 as uuidv4 } from 'uuid';
import DeleteIcon from '@mui/icons-material/Delete';
import PreviewIcon from '@mui/icons-material/Preview';
import { mask } from '../../../../utils/privacy';
import { getSelectedNodeRedux, setSelectedNodeRedux } from '../../../../redux/selectedNodeSlice';
import handleClickFindTargetPath from '../../../../utils/handleClickFindTargetPath';
import NewCreateConditionDialog from './NewCreateConditionDialog';
import transformConditionsToExpression from '../../../../utils/transformConditionsToExpression';
import SubjectConstraintDialog from '../../../../components/SubjectConstraint/SubjectConstraintDialog';
import transformSubjectConstraintsToExpression from '../../../../utils/transformSubjectConstraintsToExpression';
import { getOpenSimulatorDRG } from '../../../../redux/layoutControlSlice';
import { getCurrentDRG, setCurrentDRG } from '../../../../redux/drgMgtSlice';

function RegulatoryRightSide(props) {

    const {
        open,
        setNodes,
        setOpenSelectResource,
        nodes,
        edges,
        setOpenAttributeSelection,
        setOpen,
        setUpdateProperties
    } = props;
    const theme = useTheme();
    const [label, setLabel] = useState("");
    const [description, setDescription] = useState("");
    const regulatoryFile = useSelector(getCurrentDRG);
    const [resourceLabel, setResourceLabel] = useState("");
    const [conditions, setConditions] = useState([]);
    const [attributeSelection, setAttributeSelection] = useState([]);
    const dispatch = useDispatch();
    const [privacies, setPrivacies] = useState([]);
    const [attributePrivacy, setAttributePrivacy] = useState([]);
    const selectedNode = useSelector(getSelectedNodeRedux);
    const [subjectConstraints, setSubjectConstraints] = useState([]);
    const [openSubjectConstraint, setOpenSubjectConstraint] = useState(false);

    const openSimulatorDRG = useSelector(getOpenSimulatorDRG);
    const isReadOnlyMode = openSimulatorDRG;

    const conjunctionOptions = ['AND', 'OR'];

    //openCreateConditionDialog
    const [openCreateCondition, setOpenCreateCondition] = useState(false);
    const [editingOuterIndex, setEditingOuterIndex] = useState(null); // state สำหรับ outer condition index ที่กำลังแก้ไข (null = สร้างใหม่)
    const initialConditionData = {
        conjunction: '', // conjunction ที่ใช้กับ outer condition (ถ้ามี)
        subConditions: [
            {
                resourceAttribute: null,
                operator: '',
                value_property: '',
                conjunction: '' // conjunction สำหรับ sub condition ถ้าเพิ่มมากกว่า 1
            }
        ]
    };

    const [anchorElCondition, setAnchorElCondition] = useState(null);
    const [menuIndex, setMenuIndex] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const [editValue, setEditValue] = useState("");
    const [isEditing, setIsEditing] = useState(false);

    const isFirstRender = useRef(true); // ใช้อัปเดตค่าเฉพาะหลังจาก render แรกของ dialog condition 
    const isInitialRegulatoryRender = useRef(true);

    const onChangeLabel = (value) => {
        if (isReadOnlyMode) return;
        setLabel(value)
        setNodes((nds) => nds.map((node) => {
            if (node.id === selectedNode.id) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        general_properties: {
                            ...node.data.general_properties,
                            label: value,
                        }
                    },
                };
            }
            return node;
        }));
    };

    const onChangeDescription = (value) => {
        if (isReadOnlyMode) return;
        setDescription(value)
        setNodes((nds) => nds.map((node) => {
            if (node.id === selectedNode.id) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        general_properties: {
                            ...node.data.general_properties,
                            description: value
                        }
                    }
                };
            }
            return node;
        }));
    };

    const handleClick = (event) => {
        if (isReadOnlyMode) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        setOpenSelectResource(true);
        event.preventDefault();
        event.stopPropagation();
    };

    const handleGetResource = () => {
        const root_node = nodes.find((node) => node.type === "root");
        const is_resource = root_node?.data?.general_properties?.resource;
        if (is_resource) {
            setResourceLabel(is_resource);
        } else {
            setResourceLabel("-");
        }
    };

    const handleOpenAttributeSelection = () => {
        if (isReadOnlyMode) return;
        setOpenAttributeSelection(true);
    };

    const handleAddPrivacy = useCallback(() => {
        if (isReadOnlyMode) return;
        const initialPrivacy = {
            privacy_id: uuidv4(),
            method: 'masking',
            attribute: {
                name: ""
            },
            position: 'left',
            symbol: '*',
            visible_length: 3,
            error: false,
            error_text: []
        }
        const new_arr = [...privacies, initialPrivacy];
        setPrivacies(new_arr);
        onUpdatePrivacy(new_arr);
    }, [privacies, isReadOnlyMode]);

    const handleDeletePrivacy = (id) => {
        if (isReadOnlyMode) return;
        const privacy_deleted = privacies.filter((item) => item.privacy_id !== id);
        setPrivacies(privacy_deleted);
        onUpdatePrivacy(privacy_deleted);
        setUpdateProperties(true);
    };

    const handleInputChange = (id, key, value) => {
        if (isReadOnlyMode) return;
        const updatePrivacys = privacies.map((privacy) => {
            if (privacy?.privacy_id === id) {
                let newValue = { ...privacy };

                // Check privacy method
                if (key === 'method' && value !== privacy?.method && value === 'masking') {
                    newValue = {
                        privacy_id: privacy?.privacy_id,
                        // method: value,
                        attribute: {
                            name: ""
                        },
                        position: 'left',
                        symbol: '*',
                        visible_length: 3,
                        error: false,
                        error_text: []
                    }
                } else if (key === 'method' && value !== privacy?.method && value === 'encrypt') {
                    newValue = {
                        privacy_id: privacy?.privacy_id,
                        // method: value,
                        attribute: {
                            name: ""
                        },
                        error: false,
                        error_text: []
                    }
                }

                // Check attribute
                if (key === 'attribute' && privacy?.attributeFromSelectionError && privacy?.attributeFromSelectionError !== value) {
                    delete newValue.attributeFromSelectionError;
                }
                if (key === 'attribute' && value) {
                    const updateValue = {
                        ...value,
                        checked: true,
                    };
                    return {
                        ...newValue,
                        [key]: updateValue
                    }
                } else if (key === 'attribute' && !value) {
                    return {
                        ...newValue,
                        [key]: {
                            name: ""
                        },
                    }
                } else {
                    return {
                        ...newValue,
                        [key]: value
                    }
                }
            }
            return privacy;
        });
        setPrivacies(updatePrivacys);
        handleUpdatePrivacyNode(updatePrivacys);
    };

    const handleValidatePrivacyError = async (data) => {
        const validatedPrivacyConfig = data.map((privacy) => {
            if (privacy?.attribute?.name !== "" && privacy?.visible_length !== "") {
                const update_privacy = { ...privacy };
                return {
                    ...update_privacy,
                    error: false,
                    error_text: []
                }
            } else {
                return {
                    ...privacy,
                    error: true,
                    error_text: ["Please complete all required fields."]
                }
            }
        });
        return validatedPrivacyConfig;
    };

    const handleUpdatePrivacyNode = async (update) => {

        const isValidated = await handleValidatePrivacyError(update);
        const hasError = isValidated.some(obj => obj.error === true);

        setNodes((nds) => nds.map((node) => {
            if (node.id === selectedNode.id && selectedNode.type === 'privacy') {
                if (hasError) {
                    const node_privacy = {
                        ...node,
                        data: {
                            ...node.data,
                            general_properties: {
                                ...node.data.general_properties,
                                privacies: isValidated
                            },
                            error: true,
                            error_text: ["No privacy configurations set. Please configure data privacy."]
                        }
                    }
                    dispatch(setSelectedNodeRedux(node_privacy));
                    return node_privacy;
                } else {
                    const node_privacy = {
                        ...node,
                        data: {
                            ...node.data,
                            general_properties: {
                                ...node.data.general_properties,
                                privacies: isValidated
                            },
                            error: false,
                            error_text: []
                        }
                    }
                    dispatch(setSelectedNodeRedux(node_privacy));
                    return node_privacy;
                }
            }
            return node;
        }));
        setUpdateProperties(true);

    };

    const onUpdatePrivacy = (new_arr) => {
        setNodes((nds) => nds.map((node) => {
            if (node.id === selectedNode.id && selectedNode.type === 'privacy') {
                const node_privacy = {
                    ...node,
                    data: {
                        ...node.data,
                        general_properties: {
                            ...node.data.general_properties,
                            privacies: new_arr
                        }
                    }
                }
                return node_privacy;
            }
            return node;
        }));
        setUpdateProperties(true);
    };

    const handleOpenCreateSubjectConstraint = () => {
        if (isReadOnlyMode) return;
        setEditingOuterIndex(null);
        setOpenSubjectConstraint(true);
        handleConditionMenuClose();
    };

    const handleOpenEditCreateSubjectConstraint = () => {
        if (isReadOnlyMode) return;
        setOpenSubjectConstraint(true);
        handleConditionMenuClose();
    };

    const getAvailableAttributesForPath = (paths, nodes) => {
        let uniquePrivacyNodes = new Map();
        let selectedAttributes = new Set();
        let selectionNodes = new Set();

        // ค้นหา privacy node ที่ไม่ซ้ำกัน และเก็บ attribute ที่ถูกเลือกทั้งหมด
        for (let path of paths) {
            for (let nodeId of path.pathNodes) {
                let node = nodes.find(n => n.id === nodeId);
                if (!node) continue;

                if (node.type === "privacy") {
                    if (!uniquePrivacyNodes.has(nodeId)) {
                        uniquePrivacyNodes.set(nodeId, node);
                    }

                    // ดึงค่าจาก privacies
                    if (node.data?.general_properties?.privacies) {
                        for (let privacy of node.data.general_properties.privacies) {
                            if (privacy.attribute?.checked) {
                                selectedAttributes.add(`${privacy.attribute.name}:${privacy.attribute.data_type}`);
                            }
                        }
                    }
                }

                if (node.type === "selection") {
                    selectionNodes.add(node);
                }
            }
        }

        // ตรวจสอบ resource_schema และเพิ่ม disabled = true ถ้ามีใน selectedAttributes
        let updatedAttributeSelection = [];
        if (uniquePrivacyNodes.size > 0) {
            let firstPrivacyNode = uniquePrivacyNodes.values().next().value;
            if (firstPrivacyNode.data?.general_properties?.resource_schema) {
                updatedAttributeSelection = firstPrivacyNode.data.general_properties.resource_schema.map(attr => {
                    let key = `${attr.name}:${attr.data_type}`;
                    return {
                        ...attr,
                        disabled: selectedAttributes.has(key),
                    };
                });
            }
        }

        // เช็ค selection node และหา attributes ที่ตรงกัน
        if (selectionNodes.size > 0) {
            let commonAttributes = null;
            for (let selectionNode of selectionNodes) {
                if (!selectionNode.data?.general_properties?.resource_schema) continue;
                let checkedAttributes = selectionNode.data.general_properties.resource_schema
                    .filter(attr => attr.checked)
                    .map(attr => `${attr.name}:${attr.data_type}`);

                if (commonAttributes === null) {
                    commonAttributes = new Set(checkedAttributes);
                } else {
                    commonAttributes = new Set([...commonAttributes].filter(attr => checkedAttributes.includes(attr)));
                }
            }

            // ถ้าไม่มี attribute ที่ตรงกันเลย return []
            if (!commonAttributes || commonAttributes.size === 0) {
                return [];
            }

            // กรองเฉพาะ attribute ที่ตรงกับ commonAttributes
            updatedAttributeSelection = updatedAttributeSelection.filter(attr => commonAttributes.has(`${attr.name}:${attr.data_type}`));
        }

        return updatedAttributeSelection;
    };

    const checkPrivacyAttributeError = (attr) => {
        if (attr.error || attr.attr_error || attr.attributeFromSelectionError) {
            return true;
        } else {
            return false;
        }
    };

    const checkPrivacyAttributeErrorText = (attr) => {
        if (attr.error) {
            return "No privacy configurations set. Please configure data privacy.";
        } else if (attr.attr_error) {
            return "Attribute no longer available. Please select another.";
        } else if (attr.attributeFromSelectionError) {
            return "No attribute selected from selection node.";
        } else {
            return "";
        }
    };

    useEffect(() => {
        if (isInitialRegulatoryRender.current) {
            isInitialRegulatoryRender.current = false;
            return;
        }

        if (regulatoryFile) {
            setOpen(false);
        }
    }, [regulatoryFile?.regulatory_diagram_id])

    useEffect(() => {
        if (selectedNode) {
            if (selectedNode?.type === "privacy") {
                const findPaths = handleClickFindTargetPath(selectedNode?.id, nodes, edges);
                const attr_disabled = getAvailableAttributesForPath(findPaths, nodes);
                setAttributePrivacy(attr_disabled);

            }
        }
    }, [selectedNode, nodes, edges])

    useEffect(() => {

        const handleCheckRemove = (general_properties) => {
            let valid_attr = [];
            const { resource_schema, removedColumns } = general_properties;
            if (removedColumns !== undefined && removedColumns.length > 0) {
                valid_attr = resource_schema.map(attr => {
                    const isRemoved = removedColumns.some(removed => removed.name === attr.name);
                    return isRemoved ? { ...attr, remove: true } : attr;
                });
            } else {
                valid_attr = resource_schema;
            }
            setAttributeSelection(valid_attr);
        };

        if (selectedNode) {
            const { type, data } = selectedNode;
            setLabel(data.general_properties.label);
            setDescription(data.general_properties.description);
            if (type === 'subject') {
                // setSubjectContraints(data?.general_properties?.subject_constraint);
                setSubjectConstraints(data?.general_properties?.subjectConstraints || []);
            } else if (type === "root") {
                const resourceLabel = data?.general_properties?.resource;
                setResourceLabel(resourceLabel || '-');
            } else if (type === "condition") {
                setConditions(data?.general_properties?.conditions || []);
            } else if (type === "selection") {
                if (data.general_properties.resource_schema) {
                    handleGetResource();
                    handleCheckRemove(data.general_properties);
                }
            } else if (type === "privacy") {
                setPrivacies(data?.general_properties?.privacies || []);
            } else {
                setPrivacies([]);
            }
        }
    }, [selectedNode])

    function arrayToTupleString(arr) {
        const values = arr.map(item =>
            typeof item === 'string' ? `'${item}'` : item
        );
        return `(${values.join(', ')})`;
    }

    const showValueTypeLabel = (attr, op, val, dataType, valueType, required) => {
        let value = val;
        if (valueType === 'Subject') {
            value = `request.subject.${val}`;
            return <span>{attr} <span>{op.toUpperCase()}</span> <span>{value}</span></span>;
        } else if (valueType === 'Parameter') {
            // value = `request.params.${val}`;
            value = `${required ? "request.params.required." : "request.params."}${val}`;
            return <span>{attr} <span>{op.toUpperCase()}</span> <span>{value}</span></span>;
        }
        if (Array.isArray(value)) {
            return <span>{attr} <span>{op.toUpperCase()}</span> <span>{arrayToTupleString(value)}</span></span>;
        } else if ((dataType === 'string' && value !== 'NULL') || dataType === 'date') {
            return <span>{attr} <span>{op.toUpperCase()}</span> <span>'{value}'</span></span>;
        } else if (dataType === 'boolean') {
            return <span>{attr} <span>{op.toUpperCase()}</span> <span>{String(value)}</span></span>;
        } else {
            return <span>{attr} <span>{op.toUpperCase()}</span> <span>{value}</span></span>;
        }
    };

    const renderConditionChip = (condition) => {
        const chips = [];
        if (Array.isArray(condition.subConditions)) {
            condition?.subConditions.forEach((sub, idx) => {
                chips.push(
                    <Chip
                        key={`sub-${idx}`}
                        // label={`${sub.resourceAttribute.name} ${sub.operator} ${sub.value_property.value}`}
                        label={showValueTypeLabel(
                            sub.resourceAttribute.name,
                            sub.operator,
                            sub.value_property.value,
                            sub.resourceAttribute.type,
                            sub.value_property.value_type,
                            sub.value_property.required
                        )}
                        sx={{ mr: 0.5, mb: 0.5 }}
                    />
                );
                if (sub.conjunction !== '') {
                    chips.push(
                        <Chip
                            key={`conjunction-${idx}`}
                            label={sub.conjunction}
                            sx={{ mr: 0.5, mb: 0.5 }}
                        />
                    );
                }
            });
        }
        return chips;
    };

    const renderSubjectConstraintChip = (condition) => {
        const chips = [];
        if (Array.isArray(condition.child)) {
            condition?.child.forEach((child, idx) => {
                chips.push(
                    <Chip
                        key={`child-${idx}`}
                        label={showValueTypeLabel(
                            child.l_operand.name,
                            child.operator,
                            child.r_operand,
                            child.l_operand.type,
                            'Constant'
                        )}
                        sx={{ mr: 0.5, mb: 0.5 }}
                    />
                );
                if (child.conjunction !== '') {
                    chips.push(
                        <Chip
                            key={`conjunction-${idx}`}
                            label={child.conjunction}
                            sx={{ mr: 0.5, mb: 0.5 }}
                        />
                    );
                }
            });
        }
        return chips;
    };

    const handleOpenConditionDialog = () => {
        if (isReadOnlyMode) return;
        setOpenCreateCondition(true);
        handleConditionMenuClose();
    };

    const handleAddNewCondition = () => {
        if (isReadOnlyMode) return;
        setEditingOuterIndex(null);
        setOpenCreateCondition(true);
        handleConditionMenuClose();
    };

    const handleConditionMenuClose = () => {
        setUpdateProperties(true);
        setAnchorElCondition(null);
    };

    const handleConditionMenuOpen = (event, index) => {
        if (isReadOnlyMode) return;
        setAnchorElCondition(event.currentTarget);
        setEditingOuterIndex(index);
    };

    const checkParameterRemoved = (item, file, node_id) => {
        const parameters = new Set();

        item.subConditions.forEach((sub) => {
            if (sub.value_property.parameter_id) {
                parameters.add(sub.value_property.parameter_id)
            }
        })

        if (file?.parameters && parameters.size > 0) {
            const updatedParameters = file.parameters.map(param => {
                if (parameters.has(param.id)) {
                    const updatedUsedWithNode = param.used_with_node.filter(nodeId => nodeId !== node_id);
                    return {
                        ...param,
                        used_with_node: updatedUsedWithNode
                    };
                }
                return param;
            });
            // console.log("updatedParameters:", updatedParameters);
            const updatedFile = {
                ...file,
                parameters: updatedParameters
            }
            dispatch(setCurrentDRG(updatedFile));
        }
    };

    const handleDeleteCondition = () => {
        if (isReadOnlyMode) return;
        const conditionsRemoved = conditions.filter((_, i) => i !== editingOuterIndex);

        const itemRemoved = conditions[editingOuterIndex];

        // clear node used in parameter
        checkParameterRemoved(itemRemoved, regulatoryFile, selectedNode.id);

        let conditionsUpdated = conditionsRemoved;
        if (conditionsRemoved.length > 0) {
            const lastIndex = conditionsRemoved.length - 1;
            conditionsUpdated = conditionsRemoved.map((cond, index) => {
                if (index === lastIndex) {
                    return {
                        ...cond,
                        conjunction: ""
                    };
                }
                return cond;
            });
        }
        setConditions(conditionsUpdated);
        setNodes(prev =>
            prev.map(node => {
                if (node.id !== selectedNode.id) return node;
                const expr = transformConditionsToExpression(conditionsUpdated);
                return {
                    ...node,
                    data: {
                        ...node.data,
                        general_properties: {
                            ...node.data.general_properties,
                            conditions: conditionsUpdated,
                            expression: expr
                        }
                    }
                };
            })
        );
        handleConditionMenuClose();
    };

    const handleChangeConjunction = (index, field, value) => {
        if (isReadOnlyMode) return;
        const conditionsUpdated = conditions.map((cond, i) => {
            if (i !== index) return cond;
            return {
                ...cond,
                [field]: value,
            };
        });
        setConditions(conditionsUpdated);

        setNodes(prev =>
            prev.map(node => {
                if (node.id !== selectedNode.id) return node;
                const expr = transformConditionsToExpression(conditionsUpdated);
                return {
                    ...node,
                    data: {
                        ...node.data,
                        general_properties: {
                            ...node.data.general_properties,
                            conditions: conditionsUpdated,
                            expression: expr
                        }
                    }
                };
            })
        );

    };

    const handleChangeSubjectConstraintConjunction = (index, field, value) => {
        if (isReadOnlyMode) return;
        const subjectConstraintUpdated = subjectConstraints.map((child, i) => {
            if (i !== index) return child;
            return {
                ...child,
                [field]: value,
            };
        });
        setSubjectConstraints(subjectConstraintUpdated);

        setNodes(prev =>
            prev.map(node => {
                if (node.id !== selectedNode.id) return node;
                const expression = transformSubjectConstraintsToExpression(subjectConstraintUpdated);
                return {
                    ...node,
                    data: {
                        ...node.data,
                        general_properties: {
                            ...node.data.general_properties,
                            subjectConstraints: subjectConstraintUpdated,
                            expression: expression
                        }
                    }
                };
            })
        );

    };

    const handleDeleteSubjectConstraint = () => {
        if (isReadOnlyMode) return;
        const subjectConstraintsRemoved = subjectConstraints.filter((_, i) => i !== editingOuterIndex);
        let subjectConstraintsUpdated = [];

        if (subjectConstraintsRemoved.length > 0) {
            const lastIndex = subjectConstraintsRemoved.length - 1;
            subjectConstraintsUpdated = subjectConstraintsRemoved.map((cond, index) => {
                if (index === lastIndex) {
                    return {
                        ...cond,
                        conjunction: ""
                    };
                }
                return cond;
            });
        } else {
            subjectConstraintsUpdated = subjectConstraintsRemoved;
        }

        setSubjectConstraints(subjectConstraintsUpdated);
        setNodes(prev =>
            prev.map(node => {
                if (node.id !== selectedNode.id) return node;
                const expression = transformSubjectConstraintsToExpression(subjectConstraintsUpdated);
                return {
                    ...node,
                    data: {
                        ...node.data,
                        general_properties: {
                            ...node.data.general_properties,
                            subjectConstraints: subjectConstraintsUpdated,
                            expression: expression
                        }
                    }
                };
            })
        );
        handleConditionMenuClose();
    };

    useEffect(() => {

        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        // เช็คว่าถ้าค่ากลับมาเป็น false (หลังจากการเปลี่ยนครั้งก่อนๆ)
        if (openCreateCondition === false) {
            setUpdateProperties(true);
        }
    }, [openCreateCondition]);

    useEffect(() => {
        if (isReadOnlyMode) {
            setOpenCreateCondition(false);
            setOpenSubjectConstraint(false);
            setAnchorElCondition(null);
        }
    }, [isReadOnlyMode]);

    return (
        <Box
            sx={{
                backgroundColor: 'rgba(255, 255, 255, 1)',
                p: '20px 15px 60px 15px',
                ...(isReadOnlyMode && {
                    '& .MuiInputBase-input.Mui-disabled': {
                        WebkitTextFillColor: `${theme.palette.text.primary} !important`,
                        color: `${theme.palette.text.primary} !important`,
                        opacity: 1,
                    },
                    '& .MuiSelect-select.Mui-disabled': {
                        WebkitTextFillColor: `${theme.palette.text.primary} !important`,
                        color: `${theme.palette.text.primary} !important`,
                        opacity: 1,
                    },
                    '& .MuiFormLabel-root.Mui-disabled': {
                        color: `${theme.palette.text.primary} !important`,
                    },
                    '& .MuiButton-root.Mui-disabled': {
                        color: `${theme.palette.text.primary} !important`,
                        opacity: 1,
                    },
                    '& .MuiButton-root.Mui-disabled .MuiSvgIcon-root': {
                        color: `${theme.palette.text.primary} !important`,
                    },
                    '& .MuiIconButton-root.Mui-disabled': {
                        color: `${theme.palette.text.primary} !important`,
                        opacity: 1,
                    },
                    '& .MuiIconButton-root.Mui-disabled .MuiSvgIcon-root': {
                        color: `${theme.palette.text.primary} !important`,
                    },
                    '& .MuiAutocomplete-popupIndicator.Mui-disabled': {
                        color: `${theme.palette.text.primary} !important`,
                    },
                }),
            }}
        >
            {(open && selectedNode) ? (
                <>
                    <Typography>General Properties</Typography>
                    <TextField
                        required
                        id="component-label"
                        label="Label"
                        fullWidth
                        size='small'
                        margin="normal"
                        value={selectedNode?.type === 'root' ? selectedNode?.data?.general_properties?.resource : label}
                        onChange={(e) => onChangeLabel(e.target.value)}
                        helperText={label === "" ? "No label entered. Please enter a label." : ""}
                        error={label === ""}
                        disabled={isReadOnlyMode || (selectedNode?.type === "subject" && selectedNode?.root === true || selectedNode?.type === "root")}
                    />
                    <TextField
                        id="description"
                        label="Description"
                        fullWidth
                        size='small'
                        multiline
                        rows={3}
                        margin="normal"
                        value={description}
                        onChange={(e) => onChangeDescription(e.target.value)}
                        disabled={isReadOnlyMode}
                    />
                    {(selectedNode?.type === "subject" && !selectedNode?.root) &&
                        <>
                            <Typography sx={{ marginTop: 2 }} variant='subtitle2'>Subject Constraint</Typography>
                            <div>
                                <List sx={{ padding: '0px' }}>
                                    {subjectConstraints.map((group, outerIndex) => {
                                        return (
                                            <Box key={outerIndex}>
                                                <ListItem
                                                    sx={{
                                                        position: 'relative',
                                                        border: '1px solid #ccc',
                                                        margin: '10px 0px',
                                                        padding: '5px 5px 0px 5px',
                                                        borderRadius: '5px',
                                                        borderColor: group.error ? theme.palette.error.main : '#ccc',
                                                    }}
                                                    key={outerIndex}
                                                    secondaryAction={
                                                        <IconButton
                                                            sx={{
                                                                position: 'absolute',
                                                                right: (theme) => theme.spacing(-2.2),
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                            }}
                                                            aria-label="more"
                                                            onClick={(e) => handleConditionMenuOpen(e, outerIndex)}
                                                        >
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                    }
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            maxWidth: '100%',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {renderSubjectConstraintChip(group)}
                                                    </Box>
                                                </ListItem>
                                                {group.conjunction !== "" && (
                                                    <Box>
                                                        <FormControl size="small" sx={{ minWidth: 100 }} fullWidth>
                                                            <Select
                                                                value={group.conjunction}
                                                                onChange={(e) => handleChangeSubjectConstraintConjunction(outerIndex, 'conjunction', e.target.value)}
                                                                disabled={isReadOnlyMode}
                                                            >
                                                                <MenuItem value="AND">AND</MenuItem>
                                                                <MenuItem value="OR">OR</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                )}
                                            </Box>
                                        )
                                    })}
                                </List>
                            </div>
                            {!openSimulatorDRG && (
                                <Button
                                    sx={{
                                        border: '1px solid #ccc',
                                        mt: 1,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    onClick={() => handleOpenCreateSubjectConstraint()}
                                >
                                    <AddIcon color='action' />
                                </Button>
                            )}
                            <Menu
                                anchorEl={anchorElCondition}
                                open={!isReadOnlyMode && Boolean(anchorElCondition)}
                                onClose={handleConditionMenuClose}
                            >
                                <MenuItem disabled={isReadOnlyMode} onClick={handleOpenEditCreateSubjectConstraint}>Edit</MenuItem>
                                <MenuItem disabled={isReadOnlyMode} onClick={handleDeleteSubjectConstraint}>Delete</MenuItem>
                            </Menu>
                        </>
                    }
                    {selectedNode?.type === "root" &&
                        <>
                            <FormControl sx={{ minWidth: 80, width: '100%', marginTop: 2 }}>
                                <TextField
                                    label="Resource"
                                    id="resource-label"
                                    fullWidth
                                    size="small"
                                    value={resourceLabel || '-'}
                                    onMouseDown={handleClick}
                                    error={selectedNode?.data?.error_dpe}
                                    disabled={isReadOnlyMode}
                                >
                                </TextField>
                            </FormControl>
                        </>
                    }
                    {(selectedNode?.type === "condition" && selectedNode?.data?.general_properties?.resource_schema) &&
                        <>
                            <Typography sx={{ marginTop: 2 }} variant='subtitle2'>Condition</Typography>
                            <Box>
                                {conditions.map((cond, outerIndex) => {
                                    return (
                                        <Box key={outerIndex}>
                                            <ListItem
                                                sx={{
                                                    position: 'relative',
                                                    border: '1px solid #ccc',
                                                    margin: '10px 0px',
                                                    padding: '5px 5px 0px 5px',
                                                    borderRadius: '5px',
                                                    borderColor: cond.error ? theme.palette.error.main : '#ccc',
                                                }}
                                                key={outerIndex}
                                                secondaryAction={
                                                    <IconButton
                                                        sx={{
                                                            position: 'absolute',
                                                            right: (theme) => theme.spacing(-2.2),
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                        }}
                                                        aria-label="more"
                                                        onClick={(e) => handleConditionMenuOpen(e, outerIndex)}
                                                    >
                                                        <MoreVertIcon />
                                                    </IconButton>
                                                }
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        maxWidth: '100%',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {renderConditionChip(cond)}
                                                </Box>
                                            </ListItem>
                                            {cond.conjunction !== "" && (
                                                <Box>
                                                    <FormControl size="small" sx={{ minWidth: 100 }} fullWidth>
                                                        <Select
                                                            value={cond.conjunction}
                                                            onChange={(e) => handleChangeConjunction(outerIndex, 'conjunction', e.target.value)}
                                                            disabled={isReadOnlyMode}
                                                        // sx={{
                                                        //     '& .MuiSelect-select': {
                                                        //         display: 'flex',
                                                        //         justifyContent: 'center',
                                                        //         alignItems: 'center',
                                                        //         textAlign: 'center',
                                                        //     },
                                                        // }}
                                                        >
                                                            <MenuItem value="AND">AND</MenuItem>
                                                            <MenuItem value="OR">OR</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Box>
                                            )}
                                        </Box>
                                    )
                                })}
                                <Button
                                    sx={{
                                        border: '1px solid #ccc',
                                        mt: 1,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    onClick={handleAddNewCondition}
                                    disabled={isReadOnlyMode}
                                >
                                    <AddIcon color='action' />
                                </Button>
                                <Menu
                                    anchorEl={anchorElCondition}
                                    open={!isReadOnlyMode && Boolean(anchorElCondition)}
                                    onClose={handleConditionMenuClose}
                                >
                                    <MenuItem disabled={isReadOnlyMode} onClick={handleOpenConditionDialog}>Edit</MenuItem>
                                    <MenuItem disabled={isReadOnlyMode} onClick={handleDeleteCondition}>Delete</MenuItem>
                                </Menu>
                            </Box>

                        </>
                    }
                    {(selectedNode?.type === "selection" && selectedNode?.data?.general_properties?.resource_schema) &&
                        <>
                            <Typography mt={2} mb={1} variant='subtitle2'>Attribute Selection</Typography>
                            <div>
                                <Stack
                                    sx={{
                                        width: '100%',
                                        border: '1px solid #ccc',
                                        borderTopLeftRadius: '5px',
                                        borderTopRightRadius: '5px',
                                        paddingLeft: '10px',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                    }}
                                    direction='row'
                                    justifyContent="space-between"
                                >
                                    <Box display="flex">
                                        <Typography
                                            variant="caption"
                                            display="block"
                                            color="primary"
                                            noWrap
                                            sx={{
                                                marginRight: '5px',
                                            }}
                                        >
                                            Resource:
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            display="block"
                                            color="black"
                                            noWrap
                                            style={{
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                // maxWidth: '40%'
                                                maxWidth: '155px'
                                            }}
                                        >
                                            {resourceLabel}
                                        </Typography>
                                    </Box>
                                    <div>
                                        <IconButton onClick={handleOpenAttributeSelection} disabled={isReadOnlyMode}>
                                            {(
                                                selectedNode?.data?.general_properties?.removedColumns
                                                && selectedNode?.data?.general_properties?.removedColumns.length > 0
                                            ) ?
                                                <Badge color="secondary" variant="dot">
                                                    <EditNoteIcon />
                                                </Badge> :
                                                <EditNoteIcon />
                                            }
                                        </IconButton>
                                    </div>
                                </Stack>
                                <div
                                    style={{
                                        border: '1px solid #ccc',
                                        borderBottomLeftRadius: '5px',
                                        borderBottomRightRadius: '5px',
                                        maxHeight: 'calc(100vh - 390px)',
                                        overflow: 'auto'
                                    }}
                                >
                                    {attributeSelection.some(item => item.checked === true) ? (
                                        <List sx={{ padding: '10px' }}>
                                            {attributeSelection.map((item, index) => {
                                                if (item.checked) {
                                                    return (
                                                        <ListItem
                                                            sx={{ padding: '0px 0px 5px 0px' }}
                                                            key={index}
                                                        >
                                                            {item.name}
                                                            {item.remove && (
                                                                <Typography
                                                                    variant="body2"
                                                                    color="#78909c"
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        marginLeft: '6px',
                                                                        marginTop: '2px'
                                                                    }}
                                                                >
                                                                    (Not Found)
                                                                </Typography>
                                                            )}
                                                        </ListItem>
                                                    )
                                                }
                                            })}
                                        </List>
                                    ) : (
                                        <div>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    paddingY: '10px',
                                                }}
                                                color='error'
                                            >Please select an attribute</Typography>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    }
                    {(selectedNode?.type === "privacy" && selectedNode?.data?.general_properties?.resource_schema) &&
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: 'auto', // เปิด scroll แนวตั้ง
                                paddingBottom: '16px',
                            }}
                        >
                            <Typography mt={2} mb={2} variant='subtitle2'>Privacy</Typography>
                            {privacies.map((item, index) => {
                                return (
                                    <Fade in={true} timeout={500} key={index}>
                                        <Box
                                            sx={{
                                                mb: 2,
                                            }}
                                        >
                                            <Stack
                                                sx={{
                                                    width: '100%',
                                                    border: '1px solid #ccc',
                                                    borderTopLeftRadius: '5px',
                                                    borderTopRightRadius: '5px',
                                                    px: '14px',
                                                    py: '6px',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                                direction='row'
                                                justifyContent="space-between"
                                            >
                                                <Box className="flex flex-row items-center gap-2">
                                                    <Typography variant="caption" color="primary">Method: </Typography>
                                                    <FormControl variant="standard" size='small' sx={{ fontSize: 14, mt: '5px' }}>
                                                        <Select
                                                            labelId="select-method"
                                                            id="method"
                                                            name="method"
                                                            value={item.method}
                                                            sx={{ fontSize: 12 }}
                                                            label="method"
                                                            onChange={(e) => handleInputChange(item.privacy_id, 'method', e.target.value)}
                                                            disabled={isReadOnlyMode}
                                                        >
                                                            <MenuItem value='masking'>Masking</MenuItem>
                                                            <MenuItem value='encrypt'>Encrypt</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Box>
                                                <IconButton sx={{ width: 24, height: 24 }} onClick={() => handleDeletePrivacy(item.privacy_id)} disabled={isReadOnlyMode}>
                                                    <DeleteIcon sx={{ width: 22, height: 22 }} className='text-gray-400 hover:text-red-800' />
                                                </IconButton>

                                            </Stack>
                                            {item.method === 'masking' && (
                                                <div
                                                    style={{
                                                        border: '1px solid #ccc',
                                                        borderBottomLeftRadius: '5px',
                                                        borderBottomRightRadius: '5px',
                                                        padding: '14px'
                                                    }}
                                                >
                                                    <Autocomplete
                                                        name="attribute-masking"
                                                        fullWidth
                                                        size='small'
                                                        id="attribute-select-masking"
                                                        options={attributePrivacy}
                                                        value={item.attribute}
                                                        onChange={(event, newValue) => {
                                                            handleInputChange(item.privacy_id, 'attribute', newValue)
                                                        }}
                                                        disabled={isReadOnlyMode}
                                                        getOptionLabel={(option) => option.name}
                                                        getOptionDisabled={(option) => option.disabled}
                                                        renderInput={(params) => <TextField
                                                            {...params}
                                                            label={item.attribute.name === "" ? "Please select attribute" : "Attribute"}
                                                            placeholder="Please select"
                                                            error={checkPrivacyAttributeError(item)}
                                                            helperText={checkPrivacyAttributeErrorText(item)}

                                                        />}
                                                    />
                                                    <Box sx={{ marginTop: 2 }}>
                                                        <TextField
                                                            type="number"
                                                            name="visible_length"
                                                            label="Visible length"
                                                            size='small'
                                                            inputProps={{ min: 0 }}
                                                            value={item.visible_length}
                                                            onChange={(e) => {
                                                                const min = 0;
                                                                var value = parseInt(e.target.value);
                                                                if (value < min) value = min;
                                                                if (!value) value = min;
                                                                handleInputChange(item.privacy_id, 'visible_length', value);
                                                            }}
                                                            variant="outlined"
                                                            fullWidth
                                                            disabled={isReadOnlyMode}
                                                        />
                                                    </Box>
                                                    <Stack direction='row' spacing={1} mt={2}>
                                                        <FormControl fullWidth size='small'>
                                                            <InputLabel id="select-position">Symbol</InputLabel>
                                                            <Select
                                                                labelId="select-symbol"
                                                                id="select-symbol"
                                                                name="symbol"
                                                                value={item.symbol}
                                                                label="Symbol"
                                                                onChange={(e) => handleInputChange(item.privacy_id, 'symbol', e.target.value)}
                                                                disabled={isReadOnlyMode}
                                                            >
                                                                <MenuItem value='*'>*</MenuItem>
                                                                <MenuItem value='#'>#</MenuItem>
                                                                <MenuItem value='$'>$</MenuItem>
                                                                <MenuItem value='@'>@</MenuItem>
                                                                <MenuItem value='?'>?</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                        <FormControl fullWidth size='small'>
                                                            <InputLabel id="select-position">Position</InputLabel>
                                                            <Select
                                                                labelId="select-position"
                                                                id="select-position"
                                                                name="position"
                                                                value={item.position}
                                                                label="Position"
                                                                onChange={(e) => handleInputChange(item.privacy_id, 'position', e.target.value)}
                                                                disabled={isReadOnlyMode}
                                                            >
                                                                <MenuItem value='left'>Left</MenuItem>
                                                                <MenuItem value='right'>Right</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Stack>
                                                    <Alert icon={<PreviewIcon fontSize="inherit" />} className='mt-3' severity="info">
                                                        {mask("Preview Message", Number(item.visible_length), item.symbol, item.position)}
                                                    </Alert>
                                                </div>
                                            )}
                                            {item.method === 'encrypt' && (
                                                <div
                                                    style={{
                                                        border: '1px solid #ccc',
                                                        borderBottomLeftRadius: '5px',
                                                        borderBottomRightRadius: '5px',
                                                        padding: '14px'
                                                    }}
                                                >
                                                    <Autocomplete
                                                        name="attribute-encrypt"
                                                        fullWidth
                                                        size='small'
                                                        id="attribute-select-encrypt"
                                                        options={attributePrivacy}
                                                        value={item.attribute}
                                                        onChange={(event, newValue) => {
                                                            handleInputChange(item.privacy_id, 'attribute', newValue)
                                                        }}
                                                        disabled={isReadOnlyMode}
                                                        getOptionLabel={(option) => option.name}
                                                        getOptionDisabled={(option) => option.disabled}
                                                        renderInput={(params) => <TextField
                                                            {...params}
                                                            label={item.attribute.name === "" ? "Please select attribute" : "Attribute"}
                                                            placeholder="Please select"
                                                            error={checkPrivacyAttributeError(item)}
                                                            helperText={checkPrivacyAttributeErrorText(item)}

                                                        />}
                                                    />
                                                </div>
                                            )}
                                        </Box>
                                    </Fade>
                                )
                            })}
                            <Button
                                sx={{
                                    border: '1px solid #ccc',
                                }}
                                variant="outlined"
                                fullWidth
                                onClick={() => handleAddPrivacy()}
                                disabled={isReadOnlyMode}
                            >
                                <AddIcon color='action' />
                            </Button>
                        </Box>
                    }
                </>
            ) : (
                <>
                    <Typography>Regulatory Workspace</Typography>
                    <Typography mt={3} variant="caption" display="block" color="grey.500">Regulatory Name</Typography>
                    <Typography>{regulatoryFile?.regulatory_diagram_name}</Typography>
                    <Typography mt={3} variant="caption" display="block" color="grey.500">Description</Typography>
                    <Typography>{regulatoryFile?.description}</Typography>
                </>
            )}
            <NewCreateConditionDialog
                open={!isReadOnlyMode && openCreateCondition}
                setOpen={setOpenCreateCondition}
                selectedNode={selectedNode}
                nodes={nodes}
                setNodes={setNodes}
                initialData={editingOuterIndex !== null ? conditions[editingOuterIndex] : initialConditionData}
                conditions={conditions}
                editingOuterIndex={editingOuterIndex}
                setEditingOuterIndex={setEditingOuterIndex}
            />
            <SubjectConstraintDialog
                open={!isReadOnlyMode && openSubjectConstraint}
                setOpen={setOpenSubjectConstraint}
                nodes={nodes}
                edges={edges}
                setNodes={setNodes}
                selectedNode={selectedNode}
                subjectConstraints={subjectConstraints}
                editingOuterIndex={editingOuterIndex}
                setUpdateProperties={setUpdateProperties}
            />
        </Box >
    )
}

export default RegulatoryRightSide